<template>
  <div>
    <div class="row text-white inner-row" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Наименование'" :value="object.name"></simple-row>
    <simple-row :name="'Нормативный период'" :value="convertToPeriod(object.lifeTime)"></simple-row>
    <simple-row :name="'Справочная комплектация'" :value="object.referenceContent"></simple-row>

    <div class="row">
      <div class="col-md-2">
        Базовые компоненты
      </div>
      <div class="col-md-10">
        <p v-for="(category, index) in object.content" :key="index">
          {{category.name}}
        </p>
      </div>
    </div>


  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";
 import {convertLongToPeriod} from "@/services/periods-service";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showCalls: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     convertToPeriod(time) {
       return time ? convertLongToPeriod(time).name : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     }
   }
 }
</script>
<style>
</style>
